<template>
  <div class="container">
    <div class="row mt-2">
      <div class="col-md-12">
        <boton-atras :nombre_ruta="'Menu'"/>
      </div>
      <div class="col-md 12">
        <h1 class="titulo-uno">presupuesto de egresos</h1>
      </div>
      <div class="col-md-12">
        <select-ejercicio
          :options="yearOptions"
          labelTitle="Categoria"
          labelDescription="Selecciona año a consultar"
          placeholder="Consultar año"
          :optionToShow="anioSelected"
          :showButton="true"
          @optionSelected="handleCategorySelected"
        />
      </div>
      <div v-if="data" class="col-md-12">
        <!-- <card-collapse-docs  :sections="data" :collapse="true" :urlServe="urlServe" /> -->
        <table-section :sections="data" :urlServe="urlServe"/>
        <div class="card-body">
          <UL>
            <LI><A :href="urlServe+'rendicion-ctas/informes-SRFT/SRFT.asp'" target="_blank">Informes Trimestrales del SRFT</A> </LI>
            <LI><A :href="urlServe+'rendicion-ctas/informes-SFU/SFU.asp'" target="_blank">Informes Trimestrales del SFU</A> </LI>                                    
          </UL>
        </div>      
      </div>
    </div>
  </div>
</template>
<script>
import mapFun from "@/common/map-fn-types.js";
import RendicionDeCuentas from "@/services/rendicionDeCuentas/rendicionDeCuentas.js";
const _serviciosRendicionC = new RendicionDeCuentas();
import mixin from "@/mixins/mixin.js";
import selectEjercicio from "../../components/selectEjercicio.vue";
import cardCollapse from "../../components/cardCollapse.vue";
import cardCollapseDocs from '../../components/cardCollapseDocs.vue';
import botonAtras from './../button-atras'
import tableSection from '../../components/table.vue';

export default {
  components: { selectEjercicio, cardCollapse, cardCollapseDocs, botonAtras, tableSection },
  data() {
    return {
      data: [],
      yearOptions: [],
      loading: false,
      anioSelected: null,
      sectionData:[],
    };
  },
  async created() {
    await this.getPresupuestoEgresos();
    await this.getAniosDocs();
  },
  mixins: [mixin],
  methods: {
    async getPresupuestoEgresos() {
        try {
            const response = await _serviciosRendicionC.getPresupuestoEgresos(mapFun.presupuestoEgresos);
            // Filtrar los datos por el año seleccionado
            this.data = response.data.filter(item => item.titulo === this.anioSelected.value);
            // this.data = this.data.map(section => ({
            //     titulo: section.anio,
            //     fecha_actualizacion: section.fecha_actualizacion,
            //     id: section.id,

            //     items: section.contenido.map(doc =>({
            //         name: doc.titulo,
            //         pdf: doc.url_pdf,
            //         word: doc.url_word,
            //         excel: doc.url_excel,
            //         rar: doc.url_comprimido,
            //         idContenido: doc.idContenido,

            //     }))
            // }))
        } catch (error) {
            console.log('error', error.message);
        }
    },


    async getAniosDocs() {
      try {
        const response = await _serviciosRendicionC.getPresupuestoEgresos(
          mapFun.presupuestoEgresos
        );
        this.yearOptions = response.data;
        this.yearOptions = this.yearOptions.map(function (mapeoSelect) {
          return {
            id: mapeoSelect.id,
            value: mapeoSelect.titulo,
            label: mapeoSelect.titulo,
          };
        });
      } catch (error) {
        console.log("error", error.message);
      }
    },
    // handleYearSelected(selectedYear) {
    //   this.anioSelected = selectedYear;
    //   this.loading = true;
    //   // Simula la carga o realiza la consulta
    //   setTimeout(() => {
    //     this.loading = false;
    //   }, 2000); // Ajusta el tiempo según tu lógica de consulta
    // },
    handleCategorySelected(selectedCategory) {
      this.anioSelected = selectedCategory;
      this.loading = true;
      // Simula la carga o realiza la consulta
      setTimeout(() => {
        this.loading = false;
      }, 2000); // Ajusta el tiempo según tu lógica de consulta
    },
  },
  watch: {
    anioSelected() {
      this.getPresupuestoEgresos();
      console.log(this.anioSelected)
    },
  },
};
</script>
<style scoped>
A{color: #212529;}
A:hover{color: #212529;}
</style>
